'use es6';

import PropTypes from 'prop-types';
import keyMirror from 'react-utils/keyMirror';
const RequestStatusTypes = keyMirror({
  UNINITIALIZED: null,
  PENDING: null,
  SUCCEEDED: null,
  FAILED: null
});
export const RequestStatusPropType = PropTypes.oneOf(Object.keys(RequestStatusTypes));
export default RequestStatusTypes;